import {SurveyData} from 'screens/InsomniaSurvey/utils/surveyData';

/**
 * Calculate the Insomnia Severity Index (ISI) score from survey responses.
 * The ISI is a 7-item questionnaire that assesses the severity of insomnia.
 * Total score ranges from 0-28, with higher scores indicating greater insomnia severity.
 *
 * @param surveyInstance - The survey instance containing ISI question responses
 * @returns The total ISI score (0-28)
 */
export const getISIScore = (): number => {
  const surveyData = SurveyData.read();

  return (
    parseInt(surveyData?.insomnia_falling_asleep ?? '0') +
    parseInt(surveyData?.insomnia_staying_asleep ?? '0') +
    parseInt(surveyData?.insomnia_waking_up ?? '0') +
    parseInt(surveyData?.insomnia_daily_functioning ?? '0') +
    parseInt(surveyData?.insomnia_sleep_pattern ?? '0') +
    parseInt(surveyData?.insomnia_noticeable_to_others ?? '0') +
    parseInt(surveyData?.insomnia_worried ?? '0')
  );
};
